const env = process.env.NODE_ENV || "development";

const domainEnvironment = {
  development: {
        domainAdminSide: "http://localhost:3000",
        domainUserSide: "http://localhost:3001",
        domainName:"",
  },
  production: {
      domainAdminSide: "https://admin.quangninhprovince.cgis.asia",
      domainUserSide: "https://quangninhprovince.cgis.asia",
      domainName:"quangninhprovince.cgis.asia",
  },
};

module.exports = domainEnvironment[env];
